import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initAuth } from "./lib/auth";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root mount node");

// OIDC zuerst: verarbeitet den Login-Callback bzw. leitet zum Login um.
// Beim Redirect wird NICHT gerendert (sonst blitzt die App kurz auf).
initAuth()
  .catch((e: unknown) => {
    // Fehlgeschlagener Login-Callback: anzeigen statt erneut umleiten
    // (Endlosschleife). Neuer Versuch per Reload.
    root.textContent = `${e instanceof Error ? e.message : String(e)} — Seite neu laden, um es erneut zu versuchen.`;
    return false;
  })
  .then((render) => {
    if (!render) return;
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  });
